'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('./../../../external/@babel/runtime/helpers/esm/extends.js');
var objectWithoutProperties = require('./../../../external/@babel/runtime/helpers/esm/objectWithoutProperties.js');
var React = require('react');
var index = require('./../../../external/classnames/index.js');

function _interopDefault (e) { return e && e.__esModule ? e : { default: e }; }

var React__default = /*#__PURE__*/_interopDefault(React);

var _excluded = ["className", "tag", "cascade", "children"];

/**
 *
 * @param {Object} props - The props object for the component.
 * @param {React.ReactNode} props.children - The content of the card body.
 * @param {string} [props.className] - Additional CSS classes to apply to the card body.
 * @param {boolean} [props.cascade] - Whether the card body should have a cascade effect.
 * @param {React.ElementType} [props.tag] - The HTML tag to use for the card body.
 *
 * @example
 * //Defaults tag='div'
 * <CardBody>
 * <p>Some text</p>
 * </CardBody>
 *
 * @returns {JSX.Element} The rendered card body component.
 */

var CardBody = function CardBody(props) {
  var className = props.className,
    _props$tag = props.tag,
    Tag = _props$tag === void 0 ? 'div' : _props$tag,
    cascade = props.cascade,
    children = props.children,
    attributes = objectWithoutProperties.default(props, _excluded);
  var classes = index.default('card-body lanl-card-body', cascade && 'card-body-cascade', className);
  if (!children) {
    throw new Error('CardBody component requires children.');
  }
  return /*#__PURE__*/React__default.default.createElement(Tag, _extends.default({
    "data-test": "card-body"
  }, attributes, {
    className: classes
  }), children);
};

exports.CardBody = CardBody;
exports.default = CardBody;
//# sourceMappingURL=CardBody.js.map
